import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="currentColor" fillRule="evenodd">
      <path d="M13 5a1 1 0 11-2 0 1 1 0 012 0zm5.028 4.156A106.57 106.57 0 0012 9c-2.343 0-4.363.06-6.028.156-.441.025-.753.267-.827.556a41.54 41.54 0 00-.788 3.688c-.146.914-.267 2.01-.356 3.253-.01.147.042.286.173.422a1 1 0 00.688.286c2.304.1 4.747.162 7.138.162 2.39 0 4.833-.063 7.138-.162a1 1 0 00.687-.286c.132-.136.184-.275.173-.423a38.273 38.273 0 00-.355-3.252 41.581 41.581 0 00-.788-3.688c-.074-.29-.386-.531-.827-.556zm2.764.058c.25.97.595 2.428.826 3.87.156.976.282 2.128.375 3.425a2.527 2.527 0 01-.733 1.959 2.997 2.997 0 01-2.036.891c-1.731.075-4.39.164-7.224.164-2.835 0-5.493-.09-7.224-.164a2.997 2.997 0 01-2.037-.891 2.527 2.527 0 01-.732-1.959c.092-1.297.219-2.45.375-3.425a44.1 44.1 0 01.826-3.87c.297-1.155 1.362-1.981 2.65-2.055C7.122 7.087 9.214 7 12 7c2.786 0 4.878.087 6.142.159 1.288.074 2.353.9 2.65 2.055z" />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth={2}
        d="M6.5 12L8 13.5 6.5 15m3-3L8 13.5 9.5 15m5-3l1.5 1.5-1.5 1.5m3-3L16 13.5l1.5 1.5"
      />
    </g>
  </svg>
);
